export const OPEN_IN_FULL_SCREEN_DP_NAME = 'OpenInFullScreenClicked';
export const RELOAD_CLICK_DP_NAME = 'ReloadHeaderIconClicked';
export const FEEDBACK_CLICK_DP_NAME = 'FeedbackFromHeaderClicked';
export const CLOSE_CLICK_DP_NAME = 'CloseFromHeaderClicked';
